import SendyListsInput from './sendy-lists-input';

export default SendyListsInput;
